import ProblemMain from "../../components/ProblemMain";
import problemKendaraanConfig from "../utils/problemKendaraanConfig";

const problemKendaraanVariant = { config: problemKendaraanConfig };

const ProblemKendaraanMain = () => {
  return <ProblemMain variant={problemKendaraanVariant} />;
};

export default ProblemKendaraanMain;
